import { useAtomValue, useSetAtom, useAtom } from "jotai";
import {
  userAtom,
  setUserAtom,
  loadingAtom,
  startLoadingAtom,
  stopLoadingAtom,
  isSnackbarOpenAtom,
  messageAtom,
  typeAtom,
  openSnackbarAtom,
  closeSnackbarAtom,
  mobileAtom,
  shareScreenOpenAtom,
  shareUrlAtom,
  creatorSubscriptionAtom,
  isModerateDialogOpenAtom,
  moderationReasonAtom,
  isCollapsedAtom,
  openModerateDialogAtom,
  closeModerateDialogAtom,
  closeShareAtom,
  shareRoleplayAtom,
  shareBotAtom,
  communityAccessRestrictedAtom,
  markCommunityAccessRestrictedAtom,
  communityContentBlockedAtom,
} from "../atoms/appAtoms";

export default function useApp() {
  const user = useAtomValue(userAtom);
  const setUser = useSetAtom(setUserAtom);
  const loading = useAtomValue(loadingAtom);
  const startLoading = useSetAtom(startLoadingAtom);
  const stopLoading = useSetAtom(stopLoadingAtom);
  const isSnackbarOpen = useAtomValue(isSnackbarOpenAtom);
  const message = useAtomValue(messageAtom);
  const type = useAtomValue(typeAtom);
  const openSnackbar = useSetAtom(openSnackbarAtom);
  const closeSnackbar = useSetAtom(closeSnackbarAtom);
  const mobile = useAtomValue(mobileAtom);
  const shareScreenOpen = useAtomValue(shareScreenOpenAtom);
  const shareUrl = useAtomValue(shareUrlAtom);
  const creatorSubscription = useAtomValue(creatorSubscriptionAtom);
  const setCreatorSubscription = useSetAtom(creatorSubscriptionAtom);
  const isModerateDialogOpen = useAtomValue(isModerateDialogOpenAtom);
  const moderationReason = useAtomValue(moderationReasonAtom);
  const [isCollapsed, setIsCollapsed] = useAtom(isCollapsedAtom);
  const handleOpenModerateDialog = useSetAtom(openModerateDialogAtom);
  const handleCloseModerateDialog = useSetAtom(closeModerateDialogAtom);
  const handleCloseShare = useSetAtom(closeShareAtom);
  const handleShareRoleplay = useSetAtom(shareRoleplayAtom);
  const handleShareBot = useSetAtom(shareBotAtom);
  const isClassroomCommunityAccessRestricted = useAtomValue(
    communityAccessRestrictedAtom,
  );
  const markCommunityAccessRestricted = useSetAtom(
    markCommunityAccessRestrictedAtom,
  );
  const [isCommunityContentBlocked, setCommunityContentBlocked] = useAtom(
    communityContentBlockedAtom,
  );

  return {
    user,
    setUser,
    loading,
    startLoading,
    stopLoading,
    isSnackbarOpen,
    message,
    type,
    openSnackbar,
    closeSnackbar,
    mobile,
    shareScreenOpen,
    shareUrl,
    creatorSubscription,
    setCreatorSubscription,
    isModerateDialogOpen,
    moderationReason,
    isCollapsed,
    setIsCollapsed,
    handleOpenModerateDialog,
    handleCloseModerateDialog,
    handleCloseShare,
    handleShareRoleplay,
    handleShareBot,
    isClassroomCommunityAccessRestricted,
    markCommunityAccessRestricted,
    // Either cause: a Texas Edition classroom, or the user's customer.
    isCommunityAccessRestricted:
      isClassroomCommunityAccessRestricted || isCommunityContentBlocked,
    setCommunityContentBlocked,
  };
}
